export const BENEFICIARY_TYPE = 'BENEFICIARY_TYPE';
export const SHOW_MODAL_ADD_BENEFICIARIES = 'SHOW_MODAL_ADD_BENEFICIARIES';
export const ADD_BENEFICIARY = 'ADD_BENEFICIARY';
export const CLEAN_BENEFICIARIES = 'CLEAN_BENEFICIARIES';
export const UPDATE_BENEFICIARIES = 'UPDATE_BENEFICIARIES';
export const REMOVE_BENEFICIARIES = 'REMOVE_BENEFICIARIES';
